import React from "react";
import { Link } from "react-router-dom";
import { Car, ArrowLeft, BookOpen, ChevronRight } from "lucide-react";
import { ThemeToggle } from "@/components/ThemeToggle";
import { SeoFooter } from "@/components/SeoFooter";
import { useSeo } from "@/lib/seo";
import { ARTICLES, BLOG_PATH } from "@/lib/blog";
import { THEMATIC_PAGES } from "@/lib/thematic";

export default function BlogIndex() {
  useSeo(
    "Conseils pour voiture sans permis (VSP) — assurance, entretien, recharge | vspo",
    "Le blog vspo : guides pratiques sur la voiture sans permis (VSP) — assurance, entretien, recharge électrique et conseils pour rouler sereinement en France.",
    BLOG_PATH
  );

  return (
    <div className="min-h-screen w-full overflow-y-auto bg-background">
      <header className="sticky top-0 z-10 border-b border-border bg-card/95 backdrop-blur-md">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-4 py-3">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary text-primary-foreground">
              <Car className="h-5 w-5" />
            </span>
            <div className="leading-tight">
              <div className="font-display text-lg font-bold text-foreground">vspo</div>
              <div className="text-[11px] text-muted-foreground">GPS voiture sans permis · 45 km/h</div>
            </div>
          </div>
          <div className="flex items-center gap-1">
            <ThemeToggle />
            <Link to="/" className="inline-flex items-center gap-1.5 rounded-lg bg-primary px-3 py-2 text-sm font-semibold text-primary-foreground" data-testid="blog-open-app">
              <ArrowLeft className="h-4 w-4" /> Ouvrir le GPS
            </Link>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-4 pb-20 pt-6">
        <div className="mb-2 flex items-center gap-2">
          <BookOpen className="h-5 w-5 text-primary" />
          <span className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Blog conseils</span>
        </div>
        <h1 className="font-display text-3xl font-bold text-foreground">Conseils pour voiture sans permis</h1>
        <p className="mt-3 text-[15px] leading-relaxed text-muted-foreground">
          Guides pratiques pour bien vivre avec votre voiture sans permis (VSP) : assurance, entretien
          et recharge. Des réponses claires aux questions que se posent les conducteurs de voiturette.
        </p>

        <div className="mt-8 space-y-3">
          {ARTICLES.map((a) => (
            <Link
              key={a.slug}
              to={`${BLOG_PATH}/${a.slug}`}
              className="flex items-center justify-between gap-3 rounded-2xl border border-border bg-card p-4 transition-colors hover:bg-muted"
              data-testid={`blog-article-link-${a.slug}`}
            >
              <div>
                <h2 className="font-display text-lg font-semibold text-foreground">{a.title}</h2>
                <p className="mt-1 text-sm text-muted-foreground">{a.description}</p>
              </div>
              <ChevronRight className="h-5 w-5 shrink-0 text-muted-foreground" />
            </Link>
          ))}
        </div>

        <section className="mt-10">
          <h2 className="font-display text-base font-bold text-foreground">Guides pratiques</h2>
          <div className="mt-3 flex flex-wrap gap-2">
            {THEMATIC_PAGES.map((t) => (
              <Link
                key={t.slug}
                to={t.path}
                className="rounded-full border border-border bg-card px-3 py-1.5 text-sm text-primary transition-colors hover:bg-muted"
                data-testid={`blog-thematic-${t.slug}`}
              >
                {t.kicker}
              </Link>
            ))}
          </div>
        </section>
      </main>
      <SeoFooter />
    </div>
  );
}
